export type ModelScoreFilterStatus = {
  enabled: boolean;
  disabledReason: string | null;
};

/**
 * Pure function that determines whether the Model Score (V2) filter should be
 * enabled. Since RGI-2348 the filter carries its own model selection, so it no
 * longer depends on the active scoring sources — only on the tenant having
 * scorable models at all. While the catalog is loading the filter stays enabled
 * (the panel renders its own loading state) to avoid sidebar flicker.
 */
export function getModelScoreFilterStatus(
  modelCount: number,
  isModelsLoading: boolean
): ModelScoreFilterStatus {
  if (modelCount === 0 && !isModelsLoading) {
    return {
      enabled: false,
      disabledReason:
        "No AI scoring models are available for your workspace yet.",
    };
  }
  return { enabled: true, disabledReason: null };
}
